import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { BrowserRouter } from 'react-router';
import * as Sentry from '@sentry/react';
import { ToastContainer } from 'react-toastify';
import { store } from './store/store';
import { Provider } from 'react-redux';
import './App.css';
import { initializeSentry } from './utils/logging.ts';

initializeSentry();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <Sentry.ErrorBoundary
        fallback={
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingTop: '45vh',
                    alignItems: 'center',
                }}
            >
                <h5>Something went wrong</h5>
                <p>
                    Our team is looking into this issue. Please refresh your browser and try again.
                </p>
            </div>
        }
    >
        <StrictMode>
            <Provider store={store}>
                <BrowserRouter>
                    <ToastContainer theme="colored" pauseOnHover closeOnClick autoClose={3000} />
                    <App />
                </BrowserRouter>
            </Provider>
        </StrictMode>
    </Sentry.ErrorBoundary>,
);
